import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import QueryParamsProxy from '../../../utils/queryParamProxy';
import screens from '../../index';
import RouteParamConstants from '../../../utils/routeParamConstants';
import store from '../../../state/store';
import Logger from '../../../lib/analytics/logger';
import { EVENT_TYPES } from '../../../lib/analytics/constants';
import ERROR_CODE from '../../../utils/errorCodes';
import { getText, TEXT_KEY } from '../../../utils/localization';
import { FE_BATTLES, FE_MISSIONS } from '../../../utils/featureFlags/constants';
import useFeatureFlags from '../../../hooks/useFeatureFlags';
import { BATTLES_FEATURE_STATUS } from '../../../screens/Battles/constants/dictionary';
import { MISSIONS_GAMEPLAY_STATUS, MISSIONS_TYPES } from '../../../screens/Missions/constants';
var middleware = function middleware(_ref) {
  var navigation = _ref.navigation,
    notificationContext = _ref.notificationContext,
    _ref$target = _ref.target,
    target = _ref$target === void 0 ? screens.Missions : _ref$target;
  var _useFeatureFlags = useFeatureFlags(),
    hasFeature = _useFeatureFlags.hasFeature;
  var missionEnabled = hasFeature(FE_MISSIONS);
  var battlesEnabled = hasFeature(FE_BATTLES);
  var errorText = target === screens.Missions ? getText(TEXT_KEY.MISSIONS_OPEN_FAILED_MESSAGE) : getText(TEXT_KEY.BATTLES_OPEN_FAILED_MESSAGE);
  var navigateToTarget = function navigateToTarget() {
    QueryParamsProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_MODAL, undefined));
    QueryParamsProxy.navigate(navigation, target);
  };
  try {
    var _store$getState$api;
    var currentMission = store.getState().missions.currentMission;
    var missionsBattles = (_store$getState$api = store.getState().api) === null || _store$getState$api === void 0 || (_store$getState$api = _store$getState$api.queries) === null || _store$getState$api === void 0 || (_store$getState$api = _store$getState$api.getBattlesAndMissions) === null || _store$getState$api === void 0 ? void 0 : _store$getState$api.data;
    if (!missionsBattles) throw new Error('Missions and Battles data not found');
    var missionsFeature = missionsBattles.missionsFeature,
      battlesSetup = missionsBattles.battlesSetup;
    if (missionEnabled && target === screens.Missions && ((missionsFeature === null || missionsFeature === void 0 ? void 0 : missionsFeature.missionsGameplayStatus) === MISSIONS_GAMEPLAY_STATUS.RUNNING || (missionsFeature === null || missionsFeature === void 0 ? void 0 : missionsFeature.missionsGameplayStatus) === MISSIONS_GAMEPLAY_STATUS.TUTORIAL)) {
      if ((currentMission === null || currentMission === void 0 ? void 0 : currentMission.missionType) === MISSIONS_TYPES.BATTLES) {
        notificationContext.addNotification({
          title: getText(TEXT_KEY.OOPS),
          message: getText(TEXT_KEY.FINISH_MISSIONS_BATTLES)
        });
        return;
      }
      navigateToTarget();
      return;
    }
    if (battlesEnabled && target === screens.Battles && (battlesSetup === null || battlesSetup === void 0 ? void 0 : battlesSetup.runningStatus) === BATTLES_FEATURE_STATUS.RUNNING) {
      if ((currentMission === null || currentMission === void 0 ? void 0 : currentMission.missionType) === MISSIONS_TYPES.EXPLORER) {
        notificationContext.addNotification({
          title: getText(TEXT_KEY.OOPS),
          message: getText(TEXT_KEY.FINISH_MISSIONS_EXPLORER)
        });
        return;
      }
      navigateToTarget();
      return;
    }
    notificationContext.addNotification({
      title: getText(TEXT_KEY.OOPS),
      message: errorText
    });
  } catch (error) {
    notificationContext.addNotification({
      title: getText(TEXT_KEY.OOPS),
      message: errorText
    });
    Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
      error: error.message,
      code: ERROR_CODE.BATTALES_MISSIONS_INIT_ERROR_CODE
    });
    return;
  }
};
export default middleware;